// BalanceWidget.tsx
import { Typography } from '@mui/material';
import { useBalance } from '../../../hooks/useBalance';
import { formatDateTime } from '../../../tools/util';

interface BalanceWidgetProps {
  note?: string;
  // color?: string;
}
export const BalanceWidget = ({ note = '' }: BalanceWidgetProps) => {
  // Хук вызовет ререндер ТОЛЬКО этого компонента
  const { balance, isLoading } = useBalance(100000);
  const color = balance?.endDate ? 
    ((balance.endDate < new Date()) ? 'orange' : 'inherit') : 
    'inherit' ;

  if (isLoading && !balance) {
    return <span className="animate-pulse">Загрузка...</span>;
  }

  return (
    <div className="balance-badge" style={{ color }}>
      <Typography variant="body2" sx={{ opacity: 1.0, }} >
        {note}
      </Typography>
      <span className="date">{formatDateTime(balance?.endDate)}</span>
    </div>
  );
};
